import { styled } from '@mui/material'
import { Body2 } from '@collaborate-health/uikit'

export const Text = styled(Body2)(({ theme }) => ({
  wordBreak: 'break-word',
  marginBottom: 0,
}))

